import {
  GetEventAndReleaseForCustomerQuery,
  GetReleaseByIdQuery,
  GetReleaseBySlugQuery,
} from "~graphql/sdk";

export type Release =
  | GetReleaseByIdQuery["release"]
  | GetReleaseBySlugQuery["getReleaseBySlug"]
  | GetEventAndReleaseForCustomerQuery["getEventAndReleaseForCustomer"]["release"];

export enum QueryParams {
  SessionStart = "start",
  SessionContinue = "continue",
}
